import image, { CATEGORY_TREASURE } from "lacinetek-common/src/images"
import Image from "components/common/image"

export default ({product, treasure, loading}) => {

	if (!product) {
		return null
	}

	return (
		<section className={`focus has-splitted black ${loading ? "skel-loading" : ""}`}>
			<div className="splitted invert vertical-centered">
				<figure className="skel">
					<picture>
						<Image src={image(treasure, CATEGORY_TREASURE)} alt={treasure.name} />
					</picture>
				</figure>
				<div className="content">
					<h1 className="title skel">{treasure.name}</h1>
					<div className="content skel" dangerouslySetInnerHTML={{ __html: treasure.description}} />
				</div>
			</div>
		</section>
	)
}
